import messages from 'app/_authenticated/funds/messages';
import useAppLanguage from 'hooks/useAppLanguage';
import { useCryptoDepositProduct } from 'hooks/useCryptoDepositProduct';
import CryptoDepositDisclaimerView from './CryptoDepositDisclaimerView';

export const CryptoDepositDisclaimerComponent = ({
  currency,
}: {
  currency: string;
}) => {
  const language = useAppLanguage();
  const depositDisclaimerMessages = messages[language].cryptoDepositDisclaimer;
  const cryptoDepositProduct = useCryptoDepositProduct(currency);

  return (
    <CryptoDepositDisclaimerView
      depositDisclaimerMessages={depositDisclaimerMessages}
      productData={cryptoDepositProduct}
    />
  );
};
